<div class="wrapper">
  <MobileComponent v-if="isMobile" />
  <DesktopComponent v-else />
  <FreeSamplesModal
    v-if="isFreeSamplesModalVisible"
    :key="freeSamplesModalKey"
    :model-value="true"
    @update:model-value="onFreeSamplesModalUpdate"
  />
  <VoucherModal
    v-if="isVoucherModalVisible"
    :model-value="true"
    @update:model-value="onVoucherModalUpdate"
  />
  <div class="pp-in wait" v-if="pendingCart || pendingCheckout || pendingAddress"></div>
</div>
